import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ButtonService {
    private buttonClickedSubject = new BehaviorSubject<Event | null>(null);
    buttonClicked$ = this.buttonClickedSubject.asObservable();

    emitButtonClicked(event: Event) {
        this.buttonClickedSubject.next(event);
    }
}
